__turbopack_context__.v({
  "barcode": "Hero-module__nLATwa__barcode",
  "bottleCanvas": "Hero-module__nLATwa__bottleCanvas",
  "effects": "Hero-module__nLATwa__effects",
  "hero": "Hero-module__nLATwa__hero",
  "heroText": "Hero-module__nLATwa__heroText",
  "ingredient": "Hero-module__nLATwa__ingredient",
  "note": "Hero-module__nLATwa__note",
  "numberOne": "Hero-module__nLATwa__numberOne",
  "scanLight": "Hero-module__nLATwa__scanLight",
  "stage": "Hero-module__nLATwa__stage",
  "technicalFrame": "Hero-module__nLATwa__technicalFrame",
  "topText": "Hero-module__nLATwa__topText",
});
